export default __webpack_public_path__ + "static/media/Rakibul-Islam.a9d52295.pdf";